/* =====================================================================
   UNCUT · ms-site.js für das Shopify-Theme (aus kit/final/script.js)
   Kleiner Scroll-Motor (Vanilla, ohne Libraries)
   - Szenen werden über data-ux-anim="typ" pro Section initialisiert
     und reagieren auf shopify:section:load / :unload (Theme-Editor).
   - Positionen werden gecacht (Neuberechnung bei Resize, ResizeObserver,
     Fonts, load). Pro Frame wird nur scrollY gelesen.
   - Fortschritt landet als CSS-Variablen auf den Elementen, das CSS baut
     daraus transform und opacity. Nichts anderes wird animiert.
   - Weiches Nachziehen (Lerp) nur am Desktop mit Maus, am Handy direkt.
   - Sicherheitsnetz im <head>: startet dieses Skript nicht, wird
     .ux-motion nach 3,5 s entfernt und alles steht statisch da.
   ===================================================================== */
(function () {
  'use strict';
  window.__uxReady = true;

  var doc = document.documentElement;
  doc.classList.add('ux-ready');
  var motion = doc.classList.contains('ux-motion');
  var mq = window.matchMedia ? function (q) { return window.matchMedia(q).matches; } : function () { return false; };
  var smooth = motion && mq('(hover: hover) and (pointer: fine)');

  /* ---------- Helfer ---------- */
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function clamp(v, a, b) { a = a === undefined ? 0 : a; b = b === undefined ? 1 : b; return v < a ? a : v > b ? b : v; }
  function seg(p, a, b) { return clamp((p - a) / (b - a)); }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function eio(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  function eout(t) { return 1 - Math.pow(1 - t, 3); }
  function px(n) { return n.toFixed(1) + 'px'; }
  function dg(n) { return n.toFixed(2) + 'deg'; }
  function nm(n) { return n.toFixed(4); }
  function setVar(el, k, v) {
    if (!el) return;
    var c = el.__uxv || (el.__uxv = {});
    if (c[k] !== v) { c[k] = v; el.style.setProperty(k, v); }
  }
  function docTop(el) {
    var t = 0;
    while (el) { t += el.offsetTop; el = el.offsetParent; }
    return t;
  }
  function splitWords(el, cls) {
    var words = [];
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var parts = n.textContent.split(/(\s+)/);
          var frag = document.createDocumentFragment();
          parts.forEach(function (t) {
            if (!t) return;
            if (/^\s+$/.test(t)) { frag.appendChild(document.createTextNode(t)); return; }
            var sp = document.createElement('span');
            sp.className = cls;
            sp.textContent = t;
            frag.appendChild(sp);
            words.push(sp);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1) {
          walk(n);
        }
      });
    })(el);
    return words;
  }

  var vw = window.innerWidth, vh = window.innerHeight, isMobile = vw < 734;
  var sy = window.scrollY || window.pageYOffset;
  var docH = doc.scrollHeight;
  var isProduct = document.body.getAttribute('data-ux-page') === 'product' || document.body.classList.contains('ms-page--product') || document.body.classList.contains('template-product');

  /* =====================================================================
     KAUFEN
     Formular: Pflicht-Haken, Button grau bis angehakt (aria-disabled),
     Absenden ohne Haken wird abgefangen und der Haken hervorgehoben.
     Auf der Produktseite führt jeder Kauf-Link zum nächsten Formular,
     so dass Haken und Button zusammen im Bild stehen.
     ===================================================================== */
  var forms = [];
  function nudge(form) {
    var consent = $('[data-ux-consent]', form);
    if (!consent) return;
    if (consent.checked) {
      var s = $('[data-ux-submit]', form);
      if (s) { try { s.focus({ preventScroll: true }); } catch (e) { s.focus(); } }
      return;
    }
    try { consent.focus({ preventScroll: true }); } catch (e) { consent.focus(); }
    var label = consent.closest ? consent.closest('.ux-check') : null;
    if (!label) return;
    label.classList.remove('is-nudged');
    void label.offsetWidth;
    label.classList.add('is-nudged');
    clearTimeout(label.__uxT);
    label.__uxT = setTimeout(function () { label.classList.remove('is-nudged'); }, 1800);
  }
  function setupForm(form) {
    if (form.__ux) return;
    form.__ux = true;
    var consent = $('[data-ux-consent]', form);
    var submit = $('[data-ux-submit]', form);
    if (!consent || !submit) return;
    function sync() {
      var ok = consent.checked;
      submit.setAttribute('aria-disabled', String(!ok));
      form.classList.toggle('is-ready', ok);
    }
    consent.addEventListener('change', sync);
    consent.addEventListener('invalid', function () { nudge(form); });
    var sending = false;
    form.addEventListener('submit', function (e) {
      if (!consent.checked) { e.preventDefault(); nudge(form); return; }
      if (!window.fetch) return;
      e.preventDefault();
      if (sending) return;
      sending = true;
      var gone = false;
      var go = function () { if (gone) return; gone = true; HTMLFormElement.prototype.submit.call(form); };
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/clear.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).then(go, go);
      setTimeout(go, 4000);
    });
    // Zurück von der Kasse (Seite aus dem Verlauf-Cache): wieder absendebereit
    window.addEventListener('pageshow', function () { sending = false; });
    sync();
    forms.push(form);
  }
  function barBottom() {
    var bar = $('[data-ux-pbar]');
    return bar ? bar.offsetTop + bar.offsetHeight : 64;
  }
  function nearestForm() {
    var mid = sy + vh / 2, best = null, bd = Infinity;
    forms.forEach(function (f) {
      if (!document.body.contains(f)) return;
      var d = Math.abs(docTop(f) - mid);
      if (d < bd) { bd = d; best = f; }
    });
    return best;
  }
  document.addEventListener('click', function (e) {
    if (!isProduct) return;
    var a = e.target.closest ? e.target.closest('a[data-buy-cta]') : null;
    if (!a) return;
    var f = nearestForm();
    if (!f) return;
    e.preventDefault();
    var target = $('.ux-check', f) || f;
    var top = Math.max(0, docTop(target) - barBottom() - 14);
    window.scrollTo({ top: top, behavior: motion ? 'smooth' : 'auto' });
    setTimeout(function () { nudge(f); }, motion ? 650 : 30);
  });

  /* =====================================================================
     PRODUKTLEISTE: Akt-Anzeige, Fortschrittslinie, hell auf hellem Grund
     ===================================================================== */
  var bar = null, actEl = null, progEl = null, acts = [], lights = [], curAct = null, actTimer = 0, lastProg = -1;
  var pinIO = null;
  function setupBar() {
    bar = $('[data-ux-pbar]');
    actEl = $('[data-ux-act]');
    progEl = $('[data-ux-progress]');
    curAct = actEl ? actEl.textContent : null;
    setupPin();
  }
  /* In Shopify steckt die Kaufleiste in <main> und klebt nur, solange <main> im Bild ist.
     Ist <main> ganz nach oben gescrollt (hohe Dawn-Fußzeile), wird ihr Rahmen fest,
     damit Kaufen auch dann sichtbar bleibt. */
  function setupPin() {
    if (pinIO) { pinIO.disconnect(); pinIO = null; }
    var wrap = bar && bar.closest ? bar.closest('.shopify-section') : null;
    var main = wrap ? wrap.parentElement : null;
    if (!wrap || !main || !('IntersectionObserver' in window)) return;
    pinIO = new IntersectionObserver(function (entries) {
      var en = entries[entries.length - 1];
      wrap.classList.toggle('is-fixed', !en.isIntersecting && en.boundingClientRect.bottom <= 0);
    });
    pinIO.observe(main);
  }
  function measureBar() {
    acts = $$('[data-act]').map(function (el) { return { top: docTop(el), label: el.getAttribute('data-act') }; })
      .sort(function (a, b) { return a.top - b.top; });
    lights = $$('[data-theme="light"]').map(function (el) { var t = docTop(el); return { top: t, bottom: t + el.offsetHeight }; });
    docH = doc.scrollHeight;
  }
  function swapAct(label) {
    curAct = label;
    if (!actEl) return;
    if (!motion) { actEl.textContent = label; return; }
    actEl.classList.add('is-out');
    clearTimeout(actTimer);
    actTimer = setTimeout(function () { actEl.textContent = label; actEl.classList.remove('is-out'); }, 200);
  }
  function updateBar() {
    if (!bar) return;
    var p = Math.round(clamp(sy / Math.max(1, docH - vh)) * 1000) / 1000;
    if (progEl && p !== lastProg) { lastProg = p; progEl.style.transform = 'scaleX(' + p + ')'; }
    var y = sy + vh * .4, label = acts.length ? acts[0].label : curAct;
    for (var i = 0; i < acts.length; i++) { if (acts[i].top <= y) label = acts[i].label; else break; }
    if (label && label !== curAct) swapAct(label);
    var cy = sy + barBottom() - 26, light = false;
    for (var j = 0; j < lights.length; j++) { if (cy >= lights[j].top && cy <= lights[j].bottom) { light = true; break; } }
    if (bar.__light !== light) { bar.__light = light; bar.classList.toggle('is-light', light); }
  }

  /* =====================================================================
     HIGHLIGHTS: Pill-Tabs steuern die Galerie
     ===================================================================== */
  function setupGallery(sc) {
    if (sc.__ux) return;
    sc.__ux = true;
    var section = sc.closest('[data-section]') || document;
    var cards = $$('.ux-hl-card', sc);
    var tabs = $$('[data-ux-tab]', section);
    var track = $('.ux-hl-track', sc);
    if (!cards.length) return;
    function active(i) {
      tabs.forEach(function (t, k) {
        var on = k === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', String(on));
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        var pad = parseFloat(getComputedStyle(track).paddingLeft) || 0;
        sc.scrollTo({ left: cards[i].offsetLeft - pad, behavior: motion ? 'smooth' : 'auto' });
        active(i);
      });
    });
    var tick = false;
    sc.addEventListener('scroll', function () {
      if (tick) return;
      tick = true;
      requestAnimationFrame(function () {
        tick = false;
        var step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : 1;
        var max = sc.scrollWidth - sc.clientWidth;
        var i = sc.scrollLeft >= max - 4 ? cards.length - 1 : Math.round(sc.scrollLeft / step);
        active(clamp(i, 0, cards.length - 1));
      });
    }, { passive: true });
  }

  /* =====================================================================
     SLIDE-INS, ZÄHLER, DIAGRAMM (IntersectionObserver)
     ===================================================================== */
  var io = null, cio = null;
  function runCount(el) {
    var to = parseFloat(el.getAttribute('data-count'));
    var pre = el.getAttribute('data-prefix') || '';
    var t0 = null, dur = 900;
    function step(ts) {
      if (t0 === null) t0 = ts;
      var t = clamp((ts - t0) / dur);
      el.textContent = pre + Math.round(to * eout(t));
      if (t < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function setupReveals(scope) {
    var reveals = $$('[data-reveal], [data-ux-chart]', scope);
    var counters = $$('[data-count]', scope);
    if (!motion || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var el = en.target;
          if (el.hasAttribute('data-ux-gallery')) {
            $$('[data-reveal]', el).forEach(function (c) { c.classList.add('is-in'); });
          } else {
            el.classList.add('is-in');
          }
          io.unobserve(el);
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
      cio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          runCount(en.target);
          cio.unobserve(en.target);
        });
      }, { threshold: 0.6 });
    }
    reveals.forEach(function (el) {
      if (el.closest('[data-ux-gallery]')) return; // Galerie-Karten kommen gemeinsam
      io.observe(el);
    });
    $$('[data-ux-gallery]', scope).forEach(function (g) { io.observe(g); });
    counters.forEach(function (el) {
      if (el.getBoundingClientRect().top > vh) {
        el.textContent = (el.getAttribute('data-prefix') || '') + '0';
        cio.observe(el);
      }
    });
  }

  /* =====================================================================
     SZENEN
     Jede Szene: { mode: 'pin' | 'pass' | 'enter', el, update(p), measure() }
     pin   = Bühne klebt, p läuft über die Pin-Strecke
     pass  = p läuft vom Eintritt unten bis zum Austritt oben
     enter = p läuft beim Hereinscrollen von 0 bis 1
     ===================================================================== */
  var scenes = [];
  var TYPES = {};

  /* ---------- HERO: iPad liegt vor dem Chrom, richtet sich auf, Seiten fächern auf ---------- */
  TYPES.hero = function (scene) {
    var stage = $('.ux-stage', scene);
    var copy = $('.ux-hero-copy', scene);
    var chrome = $('.ux-chrome', scene);
    var device = $('.ux-hero-device', scene);
    var pages = $$('.ux-fan-page', scene).map(function (el) {
      return { el: el, k: +el.getAttribute('data-k'), side: +el.getAttribute('data-side') };
    });
    var stageH = 0, y0 = 0, lieDy = 0, X = [], Y = [];
    var RZ = [0, 4, 8, 12, 16], RY = [0, 12, 20, 27, 33], S = [1, .98, .95, .92, .88];
    var RX0 = 62, RZ0 = -90, S0 = .92;
    return {
      mode: 'pin',
      measure: function () {
        stageH = stage.offsetHeight;
        var copyBottom = copy ? copy.offsetTop + copy.offsetHeight : 0;
        var chromeH = chrome.offsetHeight;
        // Das iPad liegt quer: sichtbare Höhe = Gerätebreite x cos(Neigung), Perspektive ca. +15 %.
        // Oberkante knapp unter der Mitte des Schriftzugs, damit UNCUT lesbar bleibt.
        var devW = device.offsetWidth;
        var projHalf = devW * Math.cos(RX0 * Math.PI / 180) * S0 / 2 * 1.15;
        lieDy = projHalf + chromeH * .05;
        // Schriftzug + Gerät als Block mittig in den freien Raum unter dem Text setzen
        // Höhe von allem über der Bühne (Prototyp: eigene Kopfzeile, Shopify: Dawn-Kopfzeile
        // plus Ankündigungsleiste). Nur relevant, wenn die Bühne ganz oben auf der Seite steht.
        var sceneTop = scene.getBoundingClientRect().top + (window.scrollY || 0);
        var ghH = sceneTop < 260 ? sceneTop : 0;
        var blockShift = (lieDy + projHalf - chromeH / 2) / 2;
        y0 = Math.max(0, (copyBottom - ghH) / 2 - blockShift);
        // Auf kurzen Bildschirmen nie über den Text: Oberkante der Bebas-Versalien (10 % der Box)
        // bleibt mindestens 16 px unter der Launch-Zeile
        y0 = Math.max(y0, copyBottom + 16 - (stageH - chromeH) / 2 - chromeH * .10);
        if (isMobile) {
          var f = vw / 390;
          X = [0, 86 * f, 146 * f, 192 * f, 228 * f];
          Y = [0, 10, 28, 50, 78];
        } else {
          var g = Math.min(vw / 1440, stageH / 900 * 1.15);
          X = [0, 205 * g, 360 * g, 495 * g, 610 * g];
          Y = [0, 12 * g, 36 * g, 70 * g, 112 * g];
        }
      },
      update: function (p) {
        var A = eio(seg(p, 0, .36));
        var B = eio(seg(p, .32, .74));
        var C = eout(seg(p, .74, .92));
        var T = seg(p, 0, .14);
        setVar(scene, '--ux-copy-o', nm(1 - T));
        // Ausgeblendete Buttons dürfen weder Klicks noch den Tastaturfokus abfangen (sie liegen über dem iPad)
        setVar(scene, '--ux-copy-vis', T > .95 ? 'hidden' : 'visible');
        setVar(scene, '--ux-copy-y', px(-A * stageH * .1));
        setVar(scene, '--ux-chrome-y', px(y0 + A * stageH * .06));
        setVar(scene, '--ux-chrome-s', nm(1 + A * .08));
        // Schriftzug ist komplett weg, bevor die Seiten auffächern (kein Geister-UNCUT unter dem Fächer)
        var chromeO = 1 - eout(seg(p, .08, .34));
        setVar(scene, '--ux-chrome-o', nm(chromeO));
        setVar(scene, '--ux-chrome-vis', chromeO < .005 ? 'hidden' : 'visible');
        setVar(scene, '--ux-sheen', nm(Math.sin(Math.PI * seg(p, 0, .3))));
        setVar(scene, '--ux-light-o', nm(1 - .35 * C));

        var finalY = -stageH * (isMobile ? .045 : .05);
        var devY = lerp(y0 + lieDy, finalY, A) - C * stageH * (isMobile ? .02 : .06);
        var s = lerp(S0, 1, A) * lerp(1, isMobile ? .86 : .84, B);
        setVar(scene, '--ux-dev-y', px(devY));
        setVar(scene, '--ux-dev-rx', dg(RX0 * (1 - A)));
        setVar(scene, '--ux-dev-rz', dg(RZ0 * (1 - A)));
        setVar(scene, '--ux-dev-s', nm(s));

        var show = nm(seg(p, .29, .34));
        pages.forEach(function (pg) {
          var t = eout(seg(p, .32 + pg.k * .028, .62 + pg.k * .028));
          setVar(pg.el, '--ux-tx', px(pg.side * X[pg.k] * t));
          setVar(pg.el, '--ux-ty', px(devY + Y[pg.k] * t));
          setVar(pg.el, '--ux-ry', dg(-pg.side * RY[pg.k] * t));
          setVar(pg.el, '--ux-rz', dg(pg.side * RZ[pg.k] * t));
          setVar(pg.el, '--ux-s', nm(lerp(.82, S[pg.k], t)));
          setVar(pg.el, '--ux-o', show);
        });
        setVar(scene, '--ux-cap-o', nm(C));
        setVar(scene, '--ux-cap-y', px((1 - C) * 36));
      }
    };
  };

  /* ---------- STATEMENT: Wort für Wort ---------- */
  TYPES.words = function (el) {
    var p = $('p', el);
    var words = p ? splitWords(p, 'ux-w') : [];
    var n = words.length;
    var def = {
      mode: 'custom',
      progress: function () { return clamp((sy + vh * .86 - def.top) / (vh * .56)); },
      update: function (q) {
        words.forEach(function (w, i) {
          var a = (i / n) * .8;
          var t = seg(q, a, a + .2);
          setVar(w, 'opacity', (.16 + .84 * t).toFixed(3));
        });
      }
    };
    return def;
  };

  /* ---------- STORY: Vorher-Karte dreht sich zur Nachher-Karte ---------- */
  TYPES.flip = function (scene) {
    return {
      mode: 'pin',
      update: function (p) {
        var f = eio(seg(p, .2, .66));
        setVar(scene, '--ux-flip', nm(f));
        setVar(scene, '--ux-mid', nm(4 * f * (1 - f)));
        setVar(scene, '--ux-la', nm(seg(f, 0, .45)));
        setVar(scene, '--ux-lb', nm(seg(f, .55, 1)));
      }
    };
  };

  /* ---------- MYTHEN: Wort für Wort durchgestrichen ---------- */
  TYPES.strike = function (el) {
    var lines = $$('[data-strike]', el).map(function (li) {
      return { li: li, words: splitWords(li, 'ux-cw'), top: 0 };
    });
    var def = {
      mode: 'pass',
      measure: function () { lines.forEach(function (l) { l.top = docTop(l.li); }); },
      update: function (p) {
        var vsy = def.top - vh + p * (def.h + vh); // geglättete Scrollposition
        lines.forEach(function (l) {
          var k = clamp((vsy + vh * .68 - l.top) / (vh * .2));
          var n = l.words.length;
          l.words.forEach(function (w, i) { setVar(w, '--k', nm(eio(clamp(k * n - i)))); });
          setVar(l.li, '--ux-myth-o', nm(1 - .5 * seg(k, .9, 1)));
        });
      }
    };
    return def;
  };

  /* ---------- WARUM UNCUT: CUT wird geschnitten, UN gleitet herein ---------- */
  TYPES.cut = function (scene) {
    var un = $('.ux-cut-un', scene);
    var cut = $('.ux-cut-cut', scene);
    var texts = $$('.ux-cut-text', scene);
    var strikes = $$('.ux-s', scene);
    var photo = $('.ux-cut-photo', scene);
    var unW = 0, cutW = 0, cutH = 0;
    return {
      mode: 'pin',
      measure: function () { unW = un.offsetWidth; cutW = cut.offsetWidth; cutH = cut.offsetHeight; },
      update: function (p) {
        var ln = eio(seg(p, .04, .2));
        var split = eio(seg(p, .14, .3));
        var join = eio(seg(p, .38, .58));
        var open = split * (1 - join);
        setVar(scene, '--ux-word-x', px(-(1 - join) * unW / 2));
        setVar(scene, '--ux-un-x', px(-(1 - join) * unW * .9));
        setVar(scene, '--ux-join', nm(join));
        setVar(scene, '--ux-top-x', px(-open * cutW * .045));
        setVar(scene, '--ux-top-y', px(-open * cutH * .05));
        setVar(scene, '--ux-bot-x', px(open * cutW * .045));
        setVar(scene, '--ux-bot-y', px(open * cutH * .05));
        setVar(scene, '--ux-line-s', nm(ln));
        setVar(scene, '--ux-line-o', nm(ln * (1 - seg(p, .38, .5))));
        strikes.forEach(function (s, i) { setVar(s, '--k', nm(eio(seg(p, .08 + i * .07, .2 + i * .07)))); });
        var t1 = eout(seg(p, .46, .58));
        var t2 = eout(seg(p, .68, .8));
        var vals = [
          [1, 1 - .4 * seg(p, .48, .58)],
          [t1, (.22 + .78 * t1) * (1 - .25 * seg(p, .7, .8))],
          [t2, .22 + .78 * t2]
        ];
        if (photo) setVar(photo, '--ux-ph-o', nm(.35 + .65 * eout(seg(p, .7, .86))));
        texts.forEach(function (t, i) {
          if (!vals[i]) return;
          setVar(t, '--ux-ti', nm(vals[i][0]));
          setVar(t, '--ux-to', nm(vals[i][1]));
        });
      }
    };
  };

  /* ---------- ZWEI WEGE: Karten drehen sich von der Seite herein ---------- */
  TYPES.enter = function (el) {
    setVar(el, '--ux-side', el.getAttribute('data-side') || '0');
    var img = $('.ux-way-media img', el);
    return {
      mode: 'enter',
      span: .62,
      update: function (p) {
        var e = eout(p);
        setVar(el, '--ux-e', nm(e));
        if (img) {
          setVar(img, '--ux-img-rx', dg(lerp(36, isMobile ? 10 : 6, e)));
          setVar(img, '--ux-img-y', px((1 - e) * 50));
        }
      }
    };
  };

  /* ---------- KAPITEL: Inhaltsseite dreht sich mit (Desktop) ---------- */
  TYPES.chdevice = function (dev) {
    var grid = dev.closest('.ux-ch-grid') || dev;
    return {
      mode: 'pass',
      el: grid,
      update: function (p) {
        setVar(dev, '--ux-ch-ry', dg(lerp(-24, 18, p)));
        setVar(dev, '--ux-ch-rx', dg(lerp(10, -6, p)));
      }
    };
  };

  /* ---------- ABLAUF: iPhone dreht sich herein, PDF scrollt im Display ---------- */
  TYPES.flow = function (grid) {
    var phone = $('.ux-iphone', grid);
    var screen = $('.ux-iphone-screen', grid);
    var strip = $('.ux-iphone-scroll', grid);
    var steps = $('.ux-steps', grid);
    var travel = 0, phoneTop = 0, phoneH = 0, stepsTop = 0, stepsH = 1;
    var def = {
      mode: 'pass',
      measure: function () {
        travel = phone && phone.offsetParent ? Math.max(0, strip.scrollHeight - screen.clientHeight) : 0;
        phoneTop = phone ? docTop(phone) : 0;
        phoneH = phone ? phone.offsetHeight : 0;
        stepsTop = steps ? docTop(steps) : 0;
        stepsH = steps ? Math.max(1, steps.offsetHeight) : 1;
      },
      update: function (p) {
        var vsy = def.top - vh + p * (def.h + vh);
        if (phone && phoneH) {
          var e = eout(clamp((vsy + vh - phoneTop) / (vh * .8)));
          setVar(phone, '--ux-ph-x', px((1 - e) * 90));
          setVar(phone, '--ux-ph-y', px((1 - e) * 50));
          setVar(phone, '--ux-ph-ry', dg(lerp(-34, -8, e)));
          setVar(phone, '--ux-ph-rx', dg(lerp(10, 3, e)));
          var s = clamp((vsy + vh * .55 - phoneTop) / (phoneH + vh * .1));
          setVar(strip, '--ux-strip-y', px(-travel * eio(s)));
        }
        if (steps) setVar(steps, '--ux-flow-p', nm(clamp((vsy + vh * .7 - stepsTop) / stepsH)));
      }
    };
    return def;
  };

  /* ---------- KAUFBEREICH: das PDF dreht sich ins Licht ---------- */
  TYPES.buyvisual = function (vis) {
    return {
      mode: 'pass',
      update: function (p) {
        setVar(vis, '--ux-rig-ry', dg(lerp(-30, 10, eio(p))));
        setVar(vis, '--ux-rig-rx', dg(lerp(12, -4, p)));
        setVar(vis, '--ux-spread', nm(eout(seg(p, .05, .5))));
      }
    };
  };

  /* ---------- SCHLUSS: Foto atmet beim Hereinscrollen ---------- */
  TYPES.zoom = function (fig) {
    return {
      mode: 'pass',
      update: function (p) { setVar(fig, '--ux-zoom', nm(lerp(1.14, 1, eout(seg(p, 0, .55))))); }
    };
  };

  /* =====================================================================
     MOTOR
     ===================================================================== */
  function progressOf(s) {
    if (s.progress) return s.progress();
    if (s.mode === 'pin') {
      var d = s.h - s.stageH;
      return d > 0 ? clamp((sy - s.top) / d) : (sy > s.top ? 1 : 0);
    }
    if (s.mode === 'enter') return clamp((sy + vh - s.top) / (vh * (s.span || .62)));
    return clamp((sy + vh - s.top) / (s.h + vh));
  }
  function measure() {
    vw = window.innerWidth;
    vh = window.innerHeight;
    isMobile = vw < 734;
    sy = window.scrollY || window.pageYOffset;
    scenes.forEach(function (s) {
      var target = s.el;
      s.top = docTop(target);
      s.h = target.offsetHeight;
      var st = s.mode === 'pin' ? $('.ux-stage', target) : null;
      s.stageH = st ? st.offsetHeight : vh;
      if (s.measure) s.measure();
      s.last = -1;
    });
    measureBar();
  }
  var ticking = false;
  function request() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(frame);
  }
  function frame() {
    ticking = false;
    sy = window.scrollY || window.pageYOffset;
    updateBar();
    if (!motion) return;
    var again = false;
    for (var i = 0; i < scenes.length; i++) {
      var s = scenes[i];
      var t = progressOf(s);
      if (s.cur === null) s.cur = t;
      if (smooth) {
        var d = t - s.cur;
        if (Math.abs(d) > .0006) { s.cur += d * .18; again = true; } else { s.cur = t; }
      } else {
        s.cur = t;
      }
      var r = Math.round(s.cur * 10000) / 10000;
      if (r === s.last) continue;
      s.last = r;
      s.update(r);
    }
    if (again) request();
  }

  /* ---------- Sections einzeln initialisieren (auch im Shopify-Theme-Editor) ---------- */
  function initScope(scope) {
    $$('[data-ux-buyform]', scope).forEach(setupForm);
    $$('[data-ux-gallery]', scope).forEach(setupGallery);
    setupReveals(scope);
    if (motion) {
      $$('[data-ux-anim]', scope).forEach(function (el) {
        if (el.__uxScene) return;
        var make = TYPES[el.getAttribute('data-ux-anim')];
        if (!make) return;
        var def = make(el);
        if (!def) return;
        if (!def.el) def.el = el;
        def.owner = el;
        def.cur = null;
        def.last = -1;
        def.top = 0;
        def.h = 0;
        def.stageH = vh;
        el.__uxScene = def;
        scenes.push(def);
      });
    }
  }
  function destroyScope(scope) {
    scenes = scenes.filter(function (s) {
      if (scope.contains(s.owner)) { s.owner.__uxScene = null; return false; }
      return true;
    });
    forms = forms.filter(function (f) { return !scope.contains(f); });
  }

  setupBar();
  initScope(document);
  measure();
  frame();

  var rTimer = 0;
  function remeasure() {
    clearTimeout(rTimer);
    rTimer = setTimeout(function () { measure(); request(); }, 120);
  }
  /* iOS blendet beim Scrollen die Adressleiste ein und aus. Reine Höhenänderungen
     unter 140 px lösen deshalb keine Neuberechnung aus, sonst springen die Szenen. */
  var lastW = window.innerWidth, lastH = window.innerHeight;
  function onResize() {
    var w = window.innerWidth, h = window.innerHeight;
    if (w === lastW && Math.abs(h - lastH) < 140) return;
    lastW = w; lastH = h;
    remeasure();
  }
  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', onResize);
  window.addEventListener('orientationchange', remeasure);
  window.addEventListener('load', function () { measure(); request(); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { measure(); request(); });
  if ('ResizeObserver' in window) {
    var lastBodyH = 0;
    new ResizeObserver(function () {
      var h = document.body.offsetHeight;
      if (Math.abs(h - lastBodyH) < 2) return;
      lastBodyH = h;
      remeasure();
    }).observe(document.body);
  }
  document.addEventListener('shopify:section:load', function (e) { setupBar(); initScope(e.target); measure(); request(); });
  document.addEventListener('shopify:section:unload', function (e) { destroyScope(e.target); remeasure(); });
})();
